import { connect } from 'react-redux'
import { Routes, Route } from 'react-router-dom-v5-compat'
import joinPath from 'lib/join-path'
import ArrivalDate from './ArrivalDate/arrival-date'
import Milestone from './Milestone/Milestone'
import { getArrivalDate, getIsHavingMultipleBabies } from '../../reducers'
import { setArrivalDate, setUserResponse } from '../../actions'
import { urlWithChecklistParam } from 'utils'
import withRouter from 'shared/HOC/withRouter'

export const MILESTONE_PATH = 'milestone'

const Pregnancy = ({
  arrivalDate,
  nextPath,
  isHavingMultipleBabies,
  onSaveArrivalDate,
}) => (
  <Routes>
    <Route
      index
      element={
        <ArrivalDate
          arrivalDate={arrivalDate}
          isHavingMultipleBabies={isHavingMultipleBabies}
          onSaveArrivalDate={onSaveArrivalDate}
        />
      }
    />
    <Route
      path={MILESTONE_PATH}
      element={<Milestone arrivalDate={arrivalDate} nextPath={nextPath} />}
    />
  </Routes>
)

const mapStateToProps = (state) => ({
  arrivalDate: getArrivalDate(state),
  isHavingMultipleBabies: getIsHavingMultipleBabies(state),
})

const mapDispatchToProps = (dispatch, { router, nextPath }) => ({
  onSaveArrivalDate: ({ arrivalDate, isHavingMultipleBabies }) => {
    dispatch(setArrivalDate(arrivalDate))
    dispatch(setUserResponse({ isHavingMultipleBabies }))

    var url
    if (arrivalDate) {
      url = joinPath(router.location.pathname, MILESTONE_PATH)
    } else {
      url = nextPath
    }

    url = urlWithChecklistParam(url)
    router.navigate(url)
  },
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Pregnancy)
)
